import React, { ReactElement } from "react";
import { useEuiTheme, EuiIcon } from "@elastic/eui";
import { createUseStyles } from "react-jss";

export interface IPanelSubTitleProps {
  children?: ReactElement | undefined;
  hasBorder?: boolean;
  icon?: string;
}

const useFDSubTitleStyles = createUseStyles({
  border: {
    border: "1px solid var(--border-color)",
    borderRadius: "6px",
    padding: "5px 10px",
  },
  subPanel: {
    color: "var(--text)",
    fontSize: "var(--fs12)",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "16px",
    whiteSpace: "nowrap",
    display: "inline-flex",
  },
});

export const FDSubTitle = React.memo<IPanelSubTitleProps>(
  ({ children, hasBorder = false, icon }) => {
    const classes = useFDSubTitleStyles();
    const theme = useEuiTheme();
    if (!children) return null;

    return (
      <span className={`${classes.subPanel} ${hasBorder ? classes.border : ""}`}>
        {icon && (
          <>
            <EuiIcon color={theme.euiTheme.colors.mediumShade} type={icon} /> &nbsp;&nbsp;
          </>
        )}
        {children}
      </span>
    );
  }
);

export const FdDateRangeTitle = React.memo<{
  range: { end: string | null; start: string | null };
  color?: any;
}>(({ range, color }) => {
  return (
    <FDSubTitle hasBorder icon={"calendar"}>
      <span style={{ textTransform: "none", ...(color && { color }) }}>
        {range.start} {range.end && " - "}
        {range.end}
      </span>
    </FDSubTitle>
  );
});
